window.progressBar = function calculateProgress(currentVal) {
  const treshold = document.querySelector('.right-drawer-vue').getAttribute('data-price-treshold');
  var progressBar = document.querySelectorAll('.footer-filled__Threshold__progress');
  var progressNum = document.querySelectorAll('.footer-filled__num');
  var progressOuter = document.querySelectorAll('.footer-filled__numOuter');
  var successMsg = document.querySelectorAll('.footer-filled__success');
  let finalPriceWithShipping = document.querySelectorAll('.footer-filled__final-total--ship-price, .ajaxcart__final-total--ship-price, .footer-filled__total-strikethrough--ship-price');
  let finalPriceWithoutShipping = document.querySelectorAll('.footer-filled__final-total--ship-free, .ajaxcart__final-total--ship-free, .footer-filled__total-strikethrough--ship-free');
  let deliveryPrice = document.querySelectorAll('.ajaxcart_delivery-price');
  let deliveryFreePrice = document.querySelectorAll('.ajaxcart_delivery-free');

  // calculate how far progress is from the total as a percentage
  var result = Math.round(100 * currentVal / treshold);
  progressBar.forEach(function (el) {
    // Reset the width to 0 to trigger the transition (optional, if needed)
    el.style.transition = "none";
    el.style.width = el.offsetWidth; // Force a repaint

    // Apply the new width with transition
    setTimeout(function () {
      el.style.transition = "width .2s ease";
      el.style.width = result + "%";
    }, 50);
  });

  // Update the progess text. If threshold is met, show success message
  var newProgressNum = treshold - currentVal;
  if (newProgressNum <= 0) {
    successMsg.forEach(function (el) {
      el.setAttribute('style', 'display: block;');
    });
    progressOuter.forEach(function (el) {
      el.setAttribute('style', 'display: none;');
    });
    progressNum.forEach(function (el) {
      el.textContent = newProgressNum.toFixed(2).toString().replace('.', ',');
    });
    deliveryPrice.forEach(price => {
      price.setAttribute('style', 'display: none;');
    });
    deliveryFreePrice.forEach(price => {
      price.setAttribute('style', 'display: block;');
    });
    finalPriceWithShipping.forEach(price => {
      price.setAttribute('style', 'display: none;');
    });
    finalPriceWithoutShipping.forEach(price => {
      price.setAttribute('style', 'display: block;');
    });
  } else {
    successMsg.forEach(function (el) {
      el.setAttribute('style', 'display: none;');
    });
    progressOuter.forEach(function (el) {
      el.setAttribute('style', 'display: flex;');
    });
    progressNum.forEach(function (el) {
      el.textContent = newProgressNum.toFixed(2).toString().replace('.', ',');
    });
    deliveryPrice.forEach(price => {
      price.setAttribute('style', 'display: block;');
    });
    deliveryFreePrice.forEach(price => {
      price.setAttribute('style', 'display: none;');
    });
    finalPriceWithShipping.forEach(price => {
      price.setAttribute('style', 'display: block;');
    });
    finalPriceWithoutShipping.forEach(price => {
      price.setAttribute('style', 'display: none;');
    });
  }
};
window.rerenderUpsell = function renderSection(sectionId, sectionUrl) {
  fetch(sectionUrl).then(response => response.text()).then(htmlContent => {
    document.getElementById(sectionId).innerHTML = htmlContent;
  }).catch(error => {
    console.error('Erreur lors du chargement de la section:', error);
  });
};